<ion-item button [detail]="false" (click)="onRowClick()">
  <ion-icon slot="start" name="hardware-chip-outline" aria-hidden="true"></ion-icon>
  <ion-label>
    <p class="crowdctrl-form-short-link-row-title">{{ title }}</p>
    <p class="crowdctrl-form-short-link-row-url">{{ row.shortUrl }}</p>
  </ion-label>
  <ion-button
    fill="clear"
    size="small"
    slot="end"
    aria-label="Copy short URL"
    (click)="onCopy($event)"
  >
    <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
  </ion-button>
</ion-item>
